var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAicalling(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.941 511.941",
    style: {
      enableBackground: "new 0 0 511.941 511.941"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M122.29,241.062c10.29-61.76,62.343-109.392,126.151-112.886"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M363.256,180.676c13.368,17.291,22.649,37.902,26.395,60.386"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M305.124,403.638c23.011,12.151,40.981,32.568,49.96,57.297c6.648,18.31-6.018,37.898-25.401,39.834 c-49.018,4.896-98.405,4.896-147.423,0c-19.383-1.936-32.049-21.524-25.401-39.834c8.979-24.73,26.949-45.146,49.96-57.297"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M255.971,414.088l-23.498,23.498c-8.557,8.557-22.773,7.672-30.043-2.003c-4.928-6.558-8.867-13.77-11.751-21.433"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M255.971,414.088l23.498,23.498c8.557,8.557,22.773,7.672,30.043-2.003c4.928-6.558,8.867-13.77,11.751-21.433"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M238.402,431.657L229.316,468c-4.031,16.125,5.233,25.447,13.389,36.322"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M273.539,431.657L282.625,468c4.031,16.125-5.233,25.447-13.389,36.322"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M137.815,282.641c26.274,3.1,51.007-7.184,67.505-26.824c3.293-3.92,9.009-4.629,13.21-1.703 c21.69,15.108,63.593,34.969,78.352,13.19c3.294-4.861,9.964-5.999,14.496-2.265c26.71,22.003,51.623,29.625,63.715,22.006"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M369.32,334.534c-16.704,46.189-60.948,79.554-113.35,79.554c-52.451,0-96.66-33.393-113.352-79.565"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 193.522,
    y1: 316.206,
    x2: 193.522,
    y2: 328.206
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 318.419,
    y1: 316.206,
    x2: 318.419,
    y2: 328.206
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M239.506,327.849c8.715,10.001,24.213,10.001,32.928,0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M92.67,278.559c1.53-8.096,3.891-16.051,7.084-23.713c4.78-11.472,17.953-16.897,29.424-12.114 c11.471,4.779,16.895,17.952,12.114,29.423c-7.678,18.426-7.678,39.56,0,57.986c6.195,14.866-4.812,31.16-20.76,31.16 c-8.812,0-17.177-5.21-20.778-13.852c-5.156-12.374-8.143-25.512-8.963-38.773"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M391.409,361.301c8.812,0,17.177-5.21,20.778-13.852c12.261-29.426,12.261-63.178,0-92.604 c-4.78-11.472-17.953-16.897-29.424-12.114c-11.471,4.779-16.895,17.952-12.114,29.423c7.678,18.426,7.678,39.56,0,57.986 C364.454,345.007,375.461,361.301,391.409,361.301z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M99.288,346.315c-25.053,0.837-46.612-19.29-46.612-45.168c0-25.9,21.575-46.003,46.612-45.167"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M412.653,346.315c25.053,0.837,46.612-19.29,46.612-45.168c0-25.9-21.575-46.003-46.612-45.167"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M60.264,276.068V263.5c0-105.392,83.739-191.593,188.177-195.563"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M431.609,177.212c17.921,36.331,20.068,65.787,20.068,98.856"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M421.534,256.565c-1.14-27.551-9.038-53.387-22.078-75.889"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M248.441,97.963c-85.593,3.846-154.49,72.934-158.034,158.603"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M301.147,113.029V75.147c0-16.569,13.431-30,30-30h45.412c16.569,0,30,13.432,30,30v37.882c0,16.569-13.431,30-30,30h-45.412 C314.579,143.029,301.147,129.598,301.147,113.029z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M371.335,45.147c2.789,7.649,4.476,15.607,5.063,23.645c0.779,10.674-9.09,18.716-18.754,15.33c-2.54-0.89-4.978-0.912-7.366-0.075 c-10.168,3.562-19.732-4.806-18.969-15.255c0.587-8.038,2.274-15.996,5.063-23.644"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M338.794,180.676c-3.883,14.617-13.525,26.211-25.862,33.001c-12.287,6.762-26.35-5.778-21.056-18.765 c1.838-4.508,3.036-9.292,3.572-14.236"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M448.606,330.291c-6.832,31.441-23.142,59.06-47.33,80.065c-14.782,12.835-34.738-9.565-19.67-22.652 c11.397-9.897,20.598-21.648,27.34-34.793"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M331.265,7.5h83c24.853,0,45,20.147,45,45v83.176c0,24.853-20.147,45-45,45H293.441c-24.853,0-45-20.147-45-45V52.5 c0-24.853,20.147-45,45-45h7.706"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAicalling);
export default __webpack_public_path__ + "static/media/aicalling.9da98cf4d229d33f48c0a8ef40b714e2.svg";
export { ForwardRef as ReactComponent };